import { cn } from '@/lib/utils'
import { formatCpf } from './studentContract'
import type { ContractIssueForm } from './useContractIssueForm'

interface ContractIdentityInputsProps {
  form: ContractIssueForm
  className?: string
}

/** CPF do "Gerar contrato", so quando a API pediu (MH13-01: o RG saiu). */
export function ContractIdentityInputs({ form, className }: ContractIdentityInputsProps) {
  const inputClass = cn(
    'h-9 w-40 rounded-lg border border-primary-300 bg-white px-3 text-sm text-neutral-900 dark:border-primary-500/40 dark:bg-neutral-900 dark:text-neutral-100',
    className,
  )

  return (
    <>
      {form.askCpf && (
        <input
          aria-label="CPF"
          inputMode="numeric"
          placeholder="CPF"
          value={form.cpf}
          onChange={(event) => form.setCpf(formatCpf(event.target.value))}
          className={inputClass}
        />
      )}
    </>
  )
}
